import React from 'react';
import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom'
// import Uniquenumber from '.src/categoryApis/Uniquenumbers'

const Vip = () => {

  function handleOnclick() {
    document.getElementById('sub-menu').style.display = 'block'
  }
  function handleSUMTOTALOnclick() {
    document.getElementById('searchbar-box').style.display = 'block'
  }
  function handleonFilter() {
    document.getElementById('search-filters').style.display = 'block'
  }


  return (

    <div className='wrapper'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-12 col-sm-12 col-md-3 col-lg-3'>
            <div className='side-nav'>
              <ul>
                <div className='sum-total'>
                  <li onClick={handleSUMTOTALOnclick}>
                    SUM TOTAL
                  </li>
                  <div id='searchbar-box'>
                    <input className='searchbar' type='text' placeholder='Like 12 or 3' />
                    <div className='button-overlay'>

                      <button className='search-button'><i class="fa-sharp fa-solid fa-magnifying-glass"></i></button>
                    </div>
                  </div>
                </div>
                <div className='search-card'>
                  <li onClick={handleonFilter}>
                    SEARCH FILTERS
                  </li>
                  <div id='search-filters'>
                    <p className='mb-1 mt-1'>SET BUDGET</p>
                    <select class="form-select-2  mb-4" aria-label="Default select example">
                      <option selected>-Select Price-</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <div className='start-with mb-4'>
                      <p className='mb-1'>START WITH (SERIES)</p>
                      <p className='start-with-num '>9<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        8  <input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        7  <input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        6  <input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input></p>
                      <p className='mb-1'>NUMBER NOT CONTAIN</p>
                      <p className='start-with-num mb-4'>0<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        1<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        2  <input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        3<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        4<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input><br />
                        5<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        6<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        7<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        8<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                        9<input class="form-check-input m-2" type="checkbox" value="" id="flexCheckDefault"></input>
                      </p>
                      <div className='btn-apply'>
                        <button>APPLY</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='category'>
                  <li onClick={handleOnclick} >
                    CATEGORY
                  </li>
                  <div id='sub-menu'>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">AB AB AB Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">AAA BBB Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">123456 Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Mirror Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Semi Mirror Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Tow Digit Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">786 Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Tripple Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Tetra Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Penta Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Hexa Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Septa Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Three Digit Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">Tetra 0000 Numbers</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                    <li id='sub-menu-opts' className='submenu-items'>
                      <Link className='links' to="/uniquenumbers">UNIQUE NUMBERS</Link>
                    </li>
                  </div>
                </div>
              </ul>
            </div>
          </div>
          <div className='col-12 col-sm-12  col-md-9 col-lg-9 mt-3'>
            <div className='container'>
              <div className='row ml-4'>
                <div className='col-12 col-md-3 col-lg-3'>
                  <select class="form-select form-select-sm  mb-4 ms-3 " aria-label=".form-select-sm example">
                    <option selected>Open this select menu</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
                <div className='col-12 col-md-9 col-lg-9'>
                  <input className='searchbar-2 w-100' type='text' placeholder='Like 12 or 3' /><i class="fa-sharp fa-solid fa-magnifying-glass search2">   search</i>
                </div>
              </div>
              <div className='filter'>
                <div className='row text-center'>
                  <div className='col '>
                    Sort By <i className="fas fa-filter"></i>
                  </div>
                  <div className='col filter-text'>
                    Price Low to High
                  </div>
                  <div className='col filter-text'>
                    Price High to Low
                  </div>
                  <div className='col filter-text'>
                    Serial Wise 0-9
                  </div>
                </div>
              </div>
              <div className='main-cards'>
                <div className='container'>
                  <div className='row text-center mt-4'>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className='col-12 col-md-6 col-lg-4'>
                      <div className='box'>
                        <div className='price'>
                          <h4>₹ 2,800</h4>
                        </div>
                        <div className='num'>8000-222-333</div>
                        <p className="sum"> Sum total: 40=4</p>
                        <div className='detail-buynow'>
                        </div>
                        <div className='icon'>
                          <a href="/"><span className='info-icon'>
                            <i class="fa-solid fa-circle-info "></i>
                          </span>
                            <span className='shop-cart-icon'>
                              <i className="fa-sharp fa-solid fa-cart-shopping"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Vip